import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { FilterValues } from 'app/core/interfaces/filtervalues.interface';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { Observable } from 'rxjs';
import * as fromRoot from '../store';
import { RootState } from '../store';
import { BaseGuard } from './base.guard';
import { goAction } from '../store/router/router.actions';
import { map } from 'rxjs/operators';

interface FilterValuesGuardData {
  filterValues: FilterValues;
  isSuperUser: boolean;
  customers: Customer[];
  selectedCustomer?: Customer;
}

export abstract class AbstractFilterValuesLoadGuard extends BaseGuard<FilterValuesGuardData> implements CanActivate, DependencyTreeCanActivate {
  constructor(name: string, protected store: Store<fromRoot.RootState>, private filterValuesGetter: (state: RootState) => FilterValues) {
    super(name);
  }

  getState(): Observable<FilterValuesGuardData> {
    return this.store.pipe(
      map(state => {
        return {
          filterValues: this.filterValuesGetter(state),
          isSuperUser: state.session.userContext.isSuperUser,
          customers: state.session.userContext.customers,
          selectedCustomer: state.session.selectedCustomer.data,
        };
      })
    );
  }

  hasFailed(t: FilterValuesGuardData): boolean {
    return t.filterValues.failed;
  }

  isLoaded(t: FilterValuesGuardData): boolean {
    return t.filterValues.loaded;
  }

  isLoading(t: FilterValuesGuardData): boolean {
    return t.filterValues.loading;
  }

  abstract loader(t: FilterValuesGuardData, params: { [p: string]: string }): void;

  abstract resetter(params: { [p: string]: string }): void;

  versionChecker(t: FilterValuesGuardData, params: { [p: string]: string }): boolean {
    if (!t.isSuperUser) {
      return t.filterValues.customerIds.length === 1 && t.selectedCustomer && t.filterValues.customerIds[0] === t.selectedCustomer.id;
    }
    return true;
  }

  navigateAway(): void {
    this.store.dispatch(goAction({ path: '/' }));
  }

  getDependencies(): any {
    return [AuthorizationGuard, CustomerInfoLoadIfNormalUserGuard];
  }

  abstract getDependencyRouteData(): any;
}
